// import React from "react";
// import face from "../../Assets/card.JPG";

// const Section5 = () => {
//   const results = [
//     {
//       number: "01",
//       text: "Build a timeless brand that authentically represents your vision and values, leaving a lasting impression on your audience.",
//     },
//     {
//       number: "02",
//       text: "Attract the right clients and customers who connect with your story and grow your business with ease.",
//     },
//     {
//       number: "03",
//       text: "Create a loyal community that engages with your content regularly, fostering trust and meaningful relationships.",
//     },
//     {
//       number: "04",
//       text: "Showcase your brand with strategic designs and impactful storytelling that stands out in the digital space.",
//     },
//     {
//       number: "05",
//       text: "Watch your brand grow as you implement customized strategies designed to meet and exceed your unique goals.",
//     },
//   ];

//   return (
//     <section className="relative bg-[#F2EFEA] py-16 px-4 min-h-screen flex items-center overflow-hidden">
//       {/* Left Image */}
//       <div className="absolute left-80 top-[250px] w-72 h-auto">
//         <img
//           src={face}
//           alt="Café interior"
//           className="object-cover rounded-lg"
//         />
//       </div>

//       {/* Right Image */}
//       <div className="absolute right-80 bottom-[150px] w-72 h-auto">
//         <img src={face} alt="Accessories" className="object-cover rounded-lg" />
//       </div>

//       {/* Main Content */}
//       <div className="max-w-4xl mx-auto">
//         {/* Header with overlapping text */}
//         <div className="relative text-center mb-20">
//           <h2
//             className="text-7xl  tracking-widest md:text-6xl "
//             style={{
//               fontFamily: "Blacker Pro Display",
//             }}
//           >
//             THE RESULTS YOU'RE
//           </h2>
//           <span
//             className="absolute tracking-widest text-4xl text-[#704735] -rotate-3 top-14 right-1/4 opacity-60 "
//             style={{
//               fontFamily: "theimpressionist",
//             }}
//           >
//             How does this sound
//           </span>
//           <h2
//             className="text-7xl tracking-widest md:text-6xl font-serif mt-4"
//             style={{
//               fontFamily: "Blacker Pro Display",
//             }}
//           >
//             GOING TO GET:
//           </h2>
//         </div>

//         {/* Results List with Overlapping Numbers */}
//         <div className="space-y-16 relative">
//           {results.map((result, index) => (
//             <div key={index} className="relative flex items-center">
//               {/* Large Background Number */}
//               <span
//                 className={`absolute text-8xl  text-white ${
//                   index % 2 === 0 ? "-right-6 mb-6" : "-left-6 mb-6"
//                 }`}
//                 style={{
//                   fontFamily: "Blacker Pro Display",
//                 }}
//               >
//                 {result.number}
//               </span>
//               {/* Text Content */}
//               <p
//                 className="text-sm  justify-center tracking-widest text-black-600 z-10 max-w-xl mx-auto"
//                 style={{
//                   fontFamily: "commuterssans-semibold",
//                 }}
//               >
//                 {result.text}
//               </p>
//             </div>
//           ))}
//         </div>

//         {/* CTA Button */}
//         <div className="mt-20">
//           <button className="bg-[#704735] text-white px-8 py-4 rounded-md text-sm cursor-pointer self-center tracking-widest">
//             VIEW MORE
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Section5;
import React from "react";
import secton4_1 from "../../Assets/seo.jpg";
import secton4_2 from "../../Assets/section4-1.jpg";
import { Link } from "react-router-dom";

const Section5 = () => {
  const results = [
    {
      number: "01",
      text: "Build a timeless brand that authentically represents your vision and values, leaving a lasting impression on your audience.",
    },
    {
      number: "02",
      text: "Attract the right clients and customers who connect with your story and grow your business with ease.",
    },
    {
      number: "03",
      text: "Create a loyal community that engages with your content regularly, fostering trust and meaningful relationships.",
    },
    {
      number: "04",
      text: "Showcase your brand with strategic designs and impactful storytelling that stands out in the digital space.",
    },
    {
      number: "05",
      text: "Watch your brand grow as you implement customized strategies designed to meet and exceed your unique goals.",
    },
  ];

  return (
    <section className="relative bg-[#F2EFEA] pt-16 lg:pb-16 px-4 min-h-screen flex items-center overflow-hidden">
      {/* Left Image */}
      <div className="absolute hidden md:block left-48 lg:left-28 top-[250px] w-60 h-auto md:left-28">
        <img
          src={secton4_1}
          alt="Café interior"
          className="object-cover rounded-lg "
        />
      </div>

      {/* Right Image */}
      <div className="hidden md:block absolute lg:right-20 bottom-[150px] w-64 h-auto md:right-28">
        <img
          src={secton4_2}
          alt="Accessories"
          className="object-cover rounded-lg "
        />
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto ">
        {/* Header with overlapping text */}
        <div className="relative text-center mb-20">
          <h2
            className=" tracking-widest text-3xl sm:text-4xl lg:text-6xl "
            style={{
              fontFamily: "Blacker Pro Display",
            }}
          >
            THE RESULTS YOU'RE
          </h2>
          <span
            className="absolute tracking-widest text-2xl -mt-6 lg:mt-0 sm:text-3xl lg:text-4xl text-[#704735] -rotate-3 top-14 lg:right-1/4 opacity-60 right-14"
            style={{
              fontFamily: "theimpressionist",
            }}
          >
            How does this sound
          </span>
          <h2
            className="text-3xl tracking-widest lg:text-6xl md:text-6xl font-serif mt-4"
            style={{
              fontFamily: "Blacker Pro Display",
            }}
          >
            GOING TO GET:
          </h2>
        </div>

        {/* Results List with Overlapping Numbers */}
        <div className="space-y-16 relative space-x-5 lg:space-x-0">
          {results.map((result, index) => (
            <div key={index} className="relative flex items-center">
              {/* Large Background Number */}
              <span
                className={`absolute text-8xl text-white ${
                  index % 2 === 0 ? "-right-3 lg:-right-6 mb-6" : "-left-6 mb-6"
                }`}
                style={{
                  fontFamily: "Blacker Pro Display",
                }}
              >
                {result.number}
              </span>
              {/* Text Content */}
              <p
                className="text-sm  justify-center tracking-widest text-black-600 z-10 max-w-xl mx-auto"
                style={{
                  fontFamily: "commuterssans-semibold",
                }}
              >
                {result.text}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="mt-16 lg:mt-20 ml-28 lg:ml-52">
          <Link to="/services">
            <button className="bg-[#704735] text-white px-8 py-4 rounded-md text-sm cursor-pointer self-center tracking-widest">
              ABOUT US
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Section5;
